import React from 'react'
import ActiveOrderContainer from '../../../../Components/OrdersPart/ActiveOrderContainer/ActiveOrderContainer'
import Layout from '../../Layout'

const ActiveOrder = () => {
  return (
    <Layout>
      <ActiveOrderContainer/>
    </Layout>
  )
}

export default ActiveOrder